var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6566 20.5834C16.2097 20.5834 15.8271 20.4243 15.5089 20.1061C15.1907 19.7878 15.0316 19.4053 15.0316 18.9584V7.04175C15.0316 6.59487 15.1907 6.21232 15.5089 5.89409C15.8271 5.57586 16.2097 5.41675 16.6566 5.41675H18.1462C18.593 5.41675 18.9756 5.57586 19.2938 5.89409C19.612 6.21232 19.7712 6.59487 19.7712 7.04175V18.9584C19.7712 19.4053 19.612 19.7878 19.2938 20.1061C18.9756 20.4243 18.593 20.5834 18.1462 20.5834H16.6566ZM7.85449 20.5834C7.40762 20.5834 7.02507 20.4243 6.70684 20.1061C6.38861 19.7878 6.22949 19.4053 6.22949 18.9584V7.04175C6.22949 6.59487 6.38861 6.21232 6.70684 5.89409C7.02507 5.57586 7.40762 5.41675 7.85449 5.41675H9.34408C9.79095 5.41675 10.1735 5.57586 10.4917 5.89409C10.81 6.21232 10.9691 6.59487 10.9691 7.04175V18.9584C10.9691 19.4053 10.81 19.7878 10.4917 20.1061C10.1735 20.4243 9.79095 20.5834 9.34408 20.5834H7.85449Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopIcon);
export default __webpack_public_path__ + "static/media/stopIcon.52032c1b.svg";
export { ForwardRef as ReactComponent };